import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { ProgramFamilyShareUrlResource } from '../../../../../../../../Types';
import { ShareUrlError, State, activating, deactivating, error, ready } from './Types';

class ShareUrlStore {
  @observable
  state: State;

  constructor(shareUrlResource: ProgramFamilyShareUrlResource) {
    makeObservable(this);
    this.state = ready(shareUrlResource);
  }

  @action
  ready = (shareUrlResource: ProgramFamilyShareUrlResource) => {
    switch (this.state.kind) {
      case 'ready':
      case 'error':
        break;
      case 'deactivating':
      case 'activating':
        this.state = ready(shareUrlResource);
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  deactivating = () => {
    switch (this.state.kind) {
      case 'ready':
        this.state = deactivating(this.state);
        break;
      case 'error':
      case 'deactivating':
      case 'activating':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  activating = () => {
    switch (this.state.kind) {
      case 'ready':
        this.state = activating(this.state);
        break;
      case 'error':
      case 'deactivating':
      case 'activating':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (err: ShareUrlError) => {
    switch (this.state.kind) {
      case 'ready':
      case 'deactivating':
      case 'activating':
        this.state = error(err, this.state);
        break;
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default ShareUrlStore;
